module.exports = __webpack_public_path__ + "img/baidu.391a3b5d.png";